import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetSubmitSurvey, submitSurvey } from "./submit-survey";

const initialState: ProcessingState = { processing: "idle" };

export const submitSurveyReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(submitSurvey.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(submitSurvey.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(submitSurvey.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetSubmitSurvey, () => {
    return initialState;
  });
});
